angular.module('qkr').factory('questService', ($http, appConfig) => ({
        getQuestSyncData() {
            console.log('getQuestSyncData called');
            return $http.get(appConfig.apiUrl + 'quest/getQuestSyncData', {withCredentials: true})
                .then((response) => response.data);
        },

        updateQuestData(changes) {
            return $http.post(appConfig.apiUrl + 'quest/updateQuestItems', {changes});
        }

	}));



// WEBPACK FOOTER //
// ./src/services/quest.services.js